module.exports = __webpack_public_path__ + "static/img/bg.f6d20bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = Lr6H
// module chunks = 1